export interface ChangelogEntry {
  version: string;
  date: string;
  changes: {
    type: 'feature' | 'improvement' | 'bugfix' | 'security';
    description: string;
  }[];
}

export const changelog: ChangelogEntry[] = [
  {
    version: '0.0.1',
    date: '2025-01-02',
    changes: [
      {
        type: 'feature',
        description: 'Initial release of MyFinalKey',
      },
      {
        type: 'feature',
        description: 'Comprehensive data vault for personal information, financial details, and final wishes',
      },
      {
        type: 'feature',
        description: 'Biometric authentication (FaceID/TouchID) for secure login',
      },
      {
        type: 'feature',
        description: 'Task-based data organization across 6 major categories',
      },
      {
        type: 'feature',
        description: 'Successor and KeyHolder management for data sharing',
      },
      {
        type: 'feature',
        description: 'AES-256-CBC encryption at rest for vault data',
      },
      {
        type: 'security',
        description: 'Privacy Policy and Terms of Service implementation',
      },
      {
        type: 'feature',
        description: 'Error boundaries for crash prevention',
      },
      {
        type: 'feature',
        description: 'Version management and update checking',
      },
    ],
  },
  // Future versions will be added here
  // Example:
  // {
  //   version: '1.0.0',
  //   date: '2025-02-01',
  //   changes: [
  //     {
  //       type: 'feature',
  //       description: 'Added push notifications for shared data updates',
  //     },
  //     {
  //       type: 'improvement',
  //       description: 'Enhanced biometric authentication with fallback options',
  //     },
  //     {
  //       type: 'bugfix',
  //       description: 'Fixed issue with data sync on slow connections',
  //     },
  //     {
  //       type: 'security',
  //       description: 'Updated encryption libraries to latest versions',
  //     },
  //   ],
  // },
];

/**
 * Get changelog for a specific version
 */
export const getChangelogForVersion = (
  version: string
): ChangelogEntry | undefined => {
  return changelog.find((entry) => entry.version === version);
};

/**
 * Get all changelogs newer than a specific version
 */
export const getChangelogsSince = (version: string): ChangelogEntry[] => {
  const versionIndex = changelog.findIndex((entry) => entry.version === version);

  if (versionIndex === -1) {
    return changelog;
  }

  return changelog.slice(0, versionIndex);
};

/**
 * Get the most recent changelog
 */
export const getLatestChangelog = (): ChangelogEntry | undefined => {
  return changelog[0];
};
